import axios from 'axios'
import { buildSignHeaders, decryptResponse } from './crypto'

// api-foot 后端请求实例：请求自动附加签名头，响应自动解密
// baseURL：默认线上；开发联调本地后端时用 .env.development 的 VUE_APP_APIFOOT_URL 覆盖
const apiFoot = axios.create({
  baseURL: process.env.VUE_APP_APIFOOT_URL || 'https://tuhaojie.asia/api-foot',
  timeout: 15000
})

// 请求拦截器：附加签名头（时间戳 + 随机数 + MD5）
apiFoot.interceptors.request.use(config => {
  const headers = buildSignHeaders()
  for (const key in headers) {
    config.headers[key] = headers[key]
  }
  return config
})

// 响应拦截器：识别加密响应并解密，调用方直接拿到原始对象
apiFoot.interceptors.response.use(response => {
  const res = response.data
  if (res && res.encrypt) {
    return decryptResponse(res.data, res.sign)
  }
  return res
}, error => {
  return Promise.reject(error)
})

export default apiFoot
